namespace AgerLMS.Administration {
    export interface RolePermissionListResponse extends Serenity.ListResponse<string> {
    }
}
